"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TimelineLegendComponent = /** @class */ (function () {
    function TimelineLegendComponent() {
    }
    return TimelineLegendComponent;
}());
exports.TimelineLegendComponent = TimelineLegendComponent;
